export default __webpack_public_path__ + "static/media/prize-1-cn.3e399a77.webp";